import React, { useState, useEffect } from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import { Context } from "../backend/context";

import { Redirect } from "react-router";
import { connect } from "react-redux";

function Notifications(props) {
  const { isLoggedIn, uid, user } = React.useContext(Context);
  const [notificationsOrdered, setNotificationOrderd] = useState([]);
  function compare(a, b) {
    if (a.createdAt < b.createdAt) {
      return 1;
    }
    if (a.createdAt > b.createdAt) {
      return -1;
    }
    return 0;
  }
  useEffect(() => {
    var data = props.notifications.sort(compare);
    setNotificationOrderd(data);
  }, [props.notifications]);

  const handleReadAll = () => {
    notificationsOrdered.forEach((element) => {
      if (!element.isRead) {
        firebase
          .database()
          .ref("userNotifications/" + uid + "/notifications/" + element.key)
          .update({
            ...element,
            isRead: true,
          });
      }
    });
  };

  const handleRead = (item) => {
    if (!item.isRead) {
      firebase
        .database()
        .ref("userNotifications/" + uid + "/notifications/" + item.key)
        .update({
          ...item,
          isRead: true,
        });
    }
  };

  return (
    <div className="py-5 container text-left badge-dark">
      {!isLoggedIn || !user ? <Redirect to="/" /> : null}
      <div className="row mt-3">
        <div className="col-8 h2">Notifications</div>{" "}
        <div className="col-4 h2">
          <button
            disabled={uid && uid.length < 2}
            onClick={handleReadAll}
            type="button"
            className="btn btn-dark btn-sm"
            style={{ backgroundColor: "black" }}
          >
            Mark All As Read
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          {notificationsOrdered && notificationsOrdered.length > 0 ? (
            notificationsOrdered.map((item, index) => {
              var d = new Date(item.createdAt);
              var date =
                d.toLocaleDateString() + " | " + d.toLocaleTimeString();
              return (
                <div
                  key={index}
                  className="row rounded-lg border-gray border p-2 m-2 text-left"
                  style={
                    item.isRead
                      ? { backgroundColor: "#292b2c" }
                      : { backgroundColor: "#292b2c" }
                  }
                >
                  <div className="col-12 btn" onClick={() => handleRead(item)}>
                    <div className="row">
                      <div
                        className="col-12 text-left"
                        style={
                          item.isRead
                            ? { color: "#bfbfbf" }
                            : { color: "#ffeb99" }
                        }
                      >
                        {item.msg}
                      </div>
                    </div>{" "}
                    <div className="row">
                      <div
                        style={
                          item.isRead
                            ? { color: "#bfbfbf", fontSize: "0.8rem" }
                            : { color: "#ffeb99", fontSize: "0.8rem" }
                        }
                        className="col-12 text-left"
                      >
                        {date}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div
              className="row rounded-lg border-gray border p-3 m-2 "
              style={{ backgroundColor: "#292b2c" }}
            >
              <div className="col-12 text-center">
                {" "}
                Don't have any notification.
              </div>{" "}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  notifications: state.notifications.notifications,
});

export default connect(mapStateToProps)(Notifications);
